<template>
  <div id="message_box">
    <div class="messageshow_icon" @click.stop="toggleState">
      <i class="fa fa-bell-o" aria-hidden="true" :style="{'color': $route.path === '/' ? '#fff' : '#000'}"></i>
      <count-to v-if="globalMessage && globalMessage.length > 0" :start-val="0" :end-val="globalMessageMaxValue" :duration="3000" class="card-panel-num"/>
      <div v-else-if="globalMessageMaxValue > 100" class="card-panel-num">100+</div>
    </div>
    <div @click.stop v-if="messageState" class="message_dropdown" slot="dropdown">
      <el-card>
        <el-tabs v-model="activeName" @tab-click="changeTab" stretch>
          <el-tab-pane label="通知" name="first">
            <div  v-if="globalMessage && globalMessage.length > 0">
              <div @click="goCenter" class="message_item" v-for="(item, key) in globalMessage" :key="key">
                <div class="message_left">
                  <div class="messageicon mes_s">S</div>
                </div>
                <div class="message_right">
                  <div class="messageRight_item">{{item.nickName}} 邀请你加入 {{item.inviterName}} {{item.inviterType === 1 ? '实验室' : '项目'}}</div>
                  <div class="messageRight_item">{{item.createdAt}}</div>
                </div>
              </div>
            </div>
            <div v-else>暂无消息</div>
          </el-tab-pane>
          <!-- <el-tab-pane label="消息" name="second">
            <div class="message_item" v-for="(item, key) in 5" :key="key">
              <div class="message_left">
                <div class="messageicon mes_m">M</div>
              </div>
              <div class="message_right">
                <div class="messageRight_item" v-if="key % 2 === 0">XXX Lab 审批成功 1111111111</div>
                <div class="messageRight_item" v-else>XXX Lab 审批驳回</div>
                <div class="messageRight_item">2019年6月30日</div>
              </div>
            </div>
          </el-tab-pane> -->
        </el-tabs>
        <div class="messagebutton">
          <el-button @click="goMessage" type="info">查看更多</el-button>
        </div>
      </el-card>
    </div>
    <el-dialog title="Message Center" :visible.sync="messageDialogState">
      <el-table
        :data="invitation">
        <el-table-column
          show-overflow-tooltip
          prop="inviteStatus"
          custom-class="message_dia"
          label="状态"
          align="center"
          width="115">
            <template slot-scope="scope">
              <el-tag :type="scope.row.inviteStatus === 0 ? 'info' : scope.row.inviteStatus === 1 ? 'success' : 'danger'">{{scope.row.inviteStatus === 0 ? '未操作' : scope.row.inviteStatus === 1 ? '已同意' : '已拒绝'}}</el-tag>
            </template>
        </el-table-column>
        <!-- <el-table-column
          prop="inviteMessege"
          label="邀请信息"
          align="center"
          width="260">
        </el-table-column> -->
        <el-table-column
          prop="brief"
          align="center"
          show-overflow-tooltip
          label="简要">
          <template slot-scope="scope">
              {{scope.row.nickName}} 邀请你加入 {{scope.row.inviterName}} {{scope.row.inviterType === 1 ? '实验室' : '项目'}}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="createdAt"
          show-overflow-tooltip
          label="日期"
          width="220">
          <template slot-scope="scope">
            <i class="el-icon-time" />
            <span>{{scope.row.createdAt}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          show-overflow-tooltip
          label="operations">
          <template slot-scope="scope">
            <span v-if="scope.row.inviteStatus === 0">
              <el-button type="primary" style="padding: 4px;" @click="confirmAddLab(scope.row)">同意</el-button>
              <el-button type="danger"  @click="refuseLab(scope.row)"  style="padding: 4px;">拒绝</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="message_page">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="paramList.pageNumber"
          :page-size="paramList.pageSize"
          layout="prev, pager, next, total"
          :total="pageTotal">
        </el-pagination>
      </div>
      <!-- <div class="table-page">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :page-size="pageSize"
          :total="allNum"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div> -->
      <el-dialog
        custom-class="message_confirm"
        title="同意加入"
        :visible.sync="confirmState"
        width="30%"
        center>
        <div>是否确定加入{{selectData.inviterName}}?</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="confirmAdd">confirm</el-button>
          <el-button @click="confirmState = false">cancel</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="拒绝加入"
        custom-class="message_confirm"
        :visible.sync="refuseState"
        width="30%"
        center>
        <div>是否拒绝加入{{selectData.inviterName}}?</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="confirmRefuse">confirm</el-button>
          <el-button @click="refuseState = false">cancel</el-button>
        </span>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import CountTo from 'vue-count-to'
import {mapActions, mapGetters} from 'vuex'
export default {
  data () {
    return {
      activeName: 'first',
      messageState: false,
      messageDialogState: false,
      confirmState: false,
      refuseState: false,
      maxValue: 30,
      invitation: [],
      pageTotal: 0,
      paramList: {
        pageSize: 20,
        pageNumber: 1,
        typeId: 1
      },
      selectData: []
    }
  },
  components: {
    CountTo
  },
  computed: {
    ...mapGetters([
      'globalMessage',
      'globalMessageMaxValue'
    ])
  },
  methods: {
    changeTab (val) {
      console.log(val)
    },
    toggleState () {
      this.messageState = !this.messageState
    },
    goMessage () {
      this.messageDialogState = true
      this.paramList.pageNumber = 1
      this.getUmsLogUserInvite(this.paramList).then((res) => {
        this.invitation = res.result
      })
      this.getUmsLogUserInviteCount({typeId: 1}).then((res) => {
        this.pageTotal = res
      })
    },
    handleCurrentChange (val) {
      this.paramList.pageNumber = val
      this.getUmsLogUserInvite(this.paramList).then((res) => {
        this.invitation = res.result
      })
    },
    goCenter () {
      this.messageDialogState = true
      this.paramList.pageNumber = 1
      this.getUmsLogUserInvite(this.paramList).then((res) => {
        this.invitation = res.result
      })
      this.getUmsLogUserInviteCount({typeId: 1}).then((res) => {
        this.pageTotal = res
      })
    },
    confirmAddLab (val) {
      this.selectData = val
      this.confirmState = true
    },
    confirmAdd () {
      this.updateUmsLogUserInvite({
        inviteId: this.selectData.id,
        inviterType: '1'
      }).then((res) => {
        this.$message({
          type: 'info',
          message: '加入成功'
        })
        this.confirmState = false
        this.getUmsLogUserInvite(this.paramList).then((res) => {
          console.log(res)
          this.invitation = res.result
        })
      })
    },
    refuseLab (val) {
      this.selectData = val
      this.refuseState = true
    },
    confirmRefuse () {
      this.updateUmsLogUserInvite({
        inviteId: this.selectData.id,
        inviterType: '2'
      }).then((res) => {
        this.$message({
          type: 'info',
          message: '已拒绝加入'
        })
        this.refuseState = false
        this.getUmsLogUserInvite(this.paramList).then((res) => {
          this.invitation = res.result
        })
      })
    },
    ...mapActions([
      'getUmsLogUserInvite',
      'updateUmsLogUserInvite',
      'getUmsLogUserInviteCount'
    ])
  },
  created () {
  },
  mounted () {
    document.addEventListener('click', () => {
      this.messageState = false
    })
  }
}
</script>
<style lang="scss">
  #message_box {
    // margin:0 14px 0 10px;
    margin-left: 20px;
    position: relative;
    z-index: 9999;
    width: 30px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    vertical-align: middle;
  }
  .messageshow_icon {
    position: relative;
    .card-panel-num {
      position: absolute;
      left: 14px;
      top: 8px;
      font-size: 12px;
      width: 20px;
      height: 16px;
      border-radius: 10px;
      border: 1px solid #fff;
      line-height: 16px;
      text-align: center;
      background-color: red;
    }
  }
  .message_dropdown {
    position: absolute;
    top: 60px;
    left: 0;
    transform: translate(-50%, 0);
    background-color: #fff;
    width: 360px;
    // .el-tabs  .el-tabs__header {
    //   margin: 0px;
    // }
    .message_item {
      height: 50px;
      border-bottom: 1px solid #efefef;
    }
    .messagebutton {
      margin-top: 20px;
    }
    .message_left {
      float: left;
      width: 20%;
    }
    .message_right {
      float: left;
      width: 80%;
      text-indent: 20px;
      text-align: left;
    }
    .messageicon {
      text-align: center;
      line-height: 40px;
      height: 40px;
      width: 40px;
      font-family: "方正姚体";
      border-radius: 100%;
      margin-top: 5px;
      margin-left: 20px;
      color: #fff;
    }
    .mes_s {
      background-color: purple;
    }
    .mes_m {
      background-color: blue;
    }
    .messageRight_item {
      height: 25px;
      line-height: 25px;
      font-size: 12px;
    }
    .messagebutton {
      text-align: center;
    }
  }
  #message_box {
    .el-dialog__header {
      padding: 0px;
      line-height: 50px;
    }
  }
  .message_page {
    padding: 10px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/firmiana/home/message.vue